//#region src/components/file-upload/file-upload-helper.ts
var e = class e {
	static size(e) {
		if (!Number.isFinite(e) || e < 0) return "Unknown size";
		if (e < 1e3) return `${String(e)} B`;
		let t = e < 1e6 ? "KB" : e < 1e9 ? "MB" : "GB", n = t === "KB" ? 1e3 : t === "MB" ? 1e6 : 1e9;
		return `${new Intl.NumberFormat("en", { maximumFractionDigits: 1 }).format(e / n)} ${t}`;
	}
	static accept(e) {
		return Object.entries(e?.accept ?? {}).flatMap(([e, t]) => [e, ...t]).join(",");
	}
	static description(t) {
		return [
			Object.entries(t?.accept ?? {}).map(([e, t]) => t.length ? t.map((e) => e.replace(/^\./, "").toUpperCase()).join(", ") : e).join(", ") || "All file types",
			t?.maxSizeBytes === void 0 ? "" : `up to ${e.size(t.maxSizeBytes)} per file`,
			t?.maxFiles === void 0 ? "" : `maximum ${String(t.maxFiles)} ${t.maxFiles === 1 ? "file" : "files"}`
		].filter(Boolean).join(" · ");
	}
	static validate(t, n, r) {
		let i = [], a = [], o = Object.entries(r?.accept ?? {});
		for (let s of t) {
			let t = o.length === 0 || o.some(([e, t]) => (e.endsWith("/*") ? s.type.toLowerCase().startsWith(e.slice(0, -1).toLowerCase()) : s.type.toLowerCase() === e.toLowerCase()) || t.some((e) => s.name.toLowerCase().endsWith(e.toLowerCase()))), c;
			s.size === 0 ? c = {
				code: "empty",
				message: "The file is empty."
			} : t ? r?.maxSizeBytes !== void 0 && s.size > r.maxSizeBytes ? c = {
				code: "size",
				message: `The file must be no larger than ${e.size(r.maxSizeBytes)}.`
			} : r?.maxFiles !== void 0 && n + i.length >= r.maxFiles && (c = {
				code: "count",
				message: `You can add up to ${String(r.maxFiles)} ${r.maxFiles === 1 ? "file" : "files"}.`
			}) : c = {
				code: "type",
				message: `The file must match the accepted types: ${e.accept(r)}.`
			}, c ? a.push({
				file: s,
				...c
			}) : i.push(s);
		}
		return {
			accepted: i,
			rejected: a
		};
	}
};
//#endregion
export { e as FileUploadHelper };
